export default "__VITE_ASSET__33bf6fc2__"